var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/multiple-menu.html');
var utils = require('../../../global/utils');
var isEmpty = utils.isEmpty;

var MultipleMenu = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            selection: '<div class="im-multiple-selection" data-index=${index}><div class="multiple-selection-icon"><i class="multiple-selection-icon-${icon}"/></div><div class="multiple-selection-text">${text}</div></div>'
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
      self._element.click(function(e){
        var _target = $(e.target);
        var index;
        if(e.target.tagName == 'DIV' || e.target.tagName == 'I'){
          if(_target.parent().hasClass('multiple-selection-icon')){
            _target = _target.parent();
          }
          if(_target.parent().hasClass('im-multiple-selection')){
            _target = _target.parent();
          }
          if(_target.hasClass('im-multiple-selection')){
            index = _target.data('index');
            if(!isEmpty(index) && self._data.selections && self._data.selections[index]){
              self.triggerEvent('click', {
                action: self._data.selections[index].action
              });
            }
          } else if (_target.hasClass('im-multiple-close')) {
            self.triggerEvent('click', {
                action: 'multipleMenuClose'
            });
          }
        }
      });
    })(this);
};
MultipleMenu.prototype = Object.create(Component.prototype);
MultipleMenu.prototype.render = function () {
    var selections = this._data.selections || [];
    var html = '';
    var self = this;
    selections.forEach(function(selection, index){
      if(selection)html += self._options.selection.replace('${text}', selection.text).replace('${icon}', selection.icon).replace('${index}', index);
    });
    this._element.find('.im-multiple-selections').html(html);
};
MultipleMenu.prototype.show = function (text) {
    Component.prototype.show.call(this);
};
MultipleMenu.prototype.hide = function () {
    Component.prototype.hide.call(this);
};

module.exports = MultipleMenu;